import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const beehiiv = defineConnector({
  identifier: "beehiiv",
  name: "Beehiiv",
  tagLine: "Newsletter platform",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://api\\.beehiiv\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Beehiiv API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [beehiiv Settings → Integrations](https://app.beehiiv.com/settings/integrations) and navigate to the **API** section. Generate a new API key and copy it.",
        },
      ],
    },
    {
      title: "Connect your Beehiiv account",
      items: [
        {
          kind: "markdown",
          content: "Enter your Beehiiv instance details and API credentials.",
        },
        {
          kind: "input",
          label: "Publication Id",
          placeholder: "pub_a3d1b49e-2a5d-4f4b-97c8-8f32e1d2f7b9",
          required: true,
          target: { kind: "configuration", field: "publicationId" },
          helperText: "The prefixed ID of the publication object",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder:
            "8ab3sjxqvHzyUnP9JhvlfT6C0wsbgr5XQrpaZZjxJkYBPy6sntvT1M2Lk94VQeRb",
          helperText: "The API key for your Beehiiv account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://api.beehiiv.com/v2/publications/${configuration.publicationId}/posts`,
  },
  publicEnvVars: ({ publicationId }) => ({
    BEEHIIV_PUBLICATION_ID: publicationId || "",
  }),
});
